import React, { FC, ReactNode, SVGProps } from 'react';
import Spacer from '@fenderdigital/ui/Spacer';

export interface PathLevel {
  id: string;
  label: string;
  url: string;
  isLocked?: boolean;
}

export const DEFAULT_PATH_LEVELS: PathLevel[] = [
  {
    url: '/path/level-1',
    id: 'level-1',
    label: 'Level 1',
  },
  {
    url: '/path/level-2',
    id: 'level-2',
    label: 'Level 2',
  },
  {
    url: '/path/level-3',
    id: 'level-3',
    label: 'Level 3',
  },
  {
    url: '/path/level-4',
    id: 'level-4',
    label: 'Level 4',
  },
  {
    url: '/path/level-5',
    id: 'level-5',
    label: 'Level 5',
  },
];

export const getIcon = (Icon: FC<SVGProps<SVGSVGElement>>): ReactNode => (
  <>
    <Icon fill="#595959" aria-hidden />
    <Spacer direction="vertical" />
  </>
);

export enum MenuPaths {
  HOME = '/',
  PATH = '/path',
  PATH_LEVEL_1 = '/path/level-1',
  PATH_LEVEL_2 = '/path/level-2',
  PATH_LEVEL_3 = '/path/level-3',
  PATH_LEVEL_4 = '/path/level-4',
  PATH_LEVEL_5 = '/path/level-5',
  SONGS = '/songs',
  COLLECTIONS = '/collections',
  SKILLS = '/skills',
  CHORD_CHALLENGE = '/chord-challenge',
  FAVORITES = '/favorites',
  ARTICLES = '/articles',
  WHATS_NEW = '/pages/announcements',
  SUPPORT = 'https://play-support.fender.com/hc/en-us',
  TOOLKIT = 'https://www.fender.com/online-guitar-tuner/',
}

export enum MenuIDs {
  HOME = 'menu-home',
  PATH = 'menu-my-path',
  PATH_LEVEL_1 = 'menu-path-level-1',
  PATH_LEVEL_2 = 'menu-path-level-2',
  PATH_LEVEL_3 = 'menu-path-level-3',
  PATH_LEVEL_4 = 'menu-path-level-4',
  PATH_LEVEL_5 = 'menu-path-level-5',
  SONGS = 'menu-songs',
  COLLECTIONS = 'menu-collections',
  SKILLS = 'menu-skills',
  CHORD_CHALLENGE = 'menu-chord-challenge',
  FAVORITES = 'menu-favorites',
  ARTICLES = 'menu-articles',
  WHATS_NEW = 'menu-announcements',
  SUPPORT = 'menu-support',
  TOOLKIT = 'menu-toolkit',
  SIGN_OUT = 'primary-sign-out',
}
